<template>
 <div>
    <div class="detailsTitle" >
       <h4>货物信息</h4>
       <div @click="back"><i class="fa fa-reply"></i></div>
    </div>
    <div class="searchBox" ref="searchBox">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="125px" size="mini">
        <div class="searchBox inpBox">
            <div class="gjhBox">
              <el-form-item label="捆包号:" prop="cargoBarcode"  label-width="90px">
                <el-input  placeholder=""   type="textarea" v-model="searchFrom.cargoBarcode" class="gjh"></el-input>
              </el-form-item>
            </div>
            <div class="item">
            <el-form-item label="货物状态:" prop="goodsStatus">
                <el-select placeholder="请选择" v-model="searchFrom.goodsStatus">
                  <el-option  label="全部" value="" ></el-option>
                  <el-option  label="已在船" value="2" ></el-option>
                  <el-option  label="已卸船" value="3" ></el-option>
                </el-select>
            </el-form-item>
              <!-- <el-form-item label="货物类型:" class="jiage" prop="productTypeId">
              <el-select  v-model="searchFrom.productTypeId"  value-key="productId"  placeholder="请选择">
                <el-option v-for="item in productTypes" :label="item.name" :value="item.productId" :key="item.productId"></el-option>
              </el-select>
            </el-form-item> -->
              <el-form-item label="卸船类型:" prop="shipUnloadType">
              <el-select  v-model="searchFrom.shipUnloadType"   placeholder="请选择">
                <el-option label="全部" value=""></el-option>
                <el-option label="入库" value="1"></el-option>
                <el-option label="自提" value="2"></el-option>
                <el-option label="过驳" value="3"></el-option>
              </el-select>
            </el-form-item>
              <el-form-item label="是否货损:" prop="isDamage">
                <el-select  v-model="searchFrom.isDamage"   placeholder="请选择">
                  <el-option  label="全部" value="" ></el-option>
                  <el-option  label="是" value="1" ></el-option>
                  <el-option  label="否" value="2" ></el-option>
                </el-select>
              </el-form-item>
            <el-form-item label="查验状态:" prop="checkStatus">
                <el-select placeholder="请选择" v-model="searchFrom.checkStatus">
                  <el-option  label="全部" value="" ></el-option>
                  <el-option  label="未查验" value="1" ></el-option>
                  <el-option  label="已查验" value="2" ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="目的港口:" prop="receivingAddressName">
              <el-input  placeholder="" v-model="searchFrom.receivingAddressName"></el-input>
            </el-form-item>
              <el-form-item label="承运方:" prop="carriageFleetName">
                <el-input  placeholder="" v-model="searchFrom.carriageFleetName"></el-input>
              </el-form-item>
            <!-- <el-form-item label="舱货位采集方式:" prop="collectType">
              <el-select  v-model="searchFrom.collectType"   placeholder="请选择">
                <el-option  label="全部" value="" ></el-option>
                <el-option  label="自动" value="1" ></el-option>
                <el-option  label="手动" value="2" ></el-option>
              </el-select>
            </el-form-item> -->
             <el-form-item label="创建时间:" prop="relCreateTimes">
                    <el-date-picker
                      v-model="searchFrom.relCreateTimes"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                    ></el-date-picker>
                  </el-form-item>
            </div>
        </div>

       <div class="searchBtnBox">
         <el-form-item>
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
          <!-- <el-form-item>
            <el-button type="primary" @click="addFN">新增</el-button>
          </el-form-item> -->
          <!-- <el-form-item>
            <el-button type="primary" @click="editFN">修改</el-button>
          </el-form-item> -->
          <el-form-item>
            <el-button type="primary" @click="deleteFN">删除</el-button>
          </el-form-item>
           <el-form-item>
            <el-button type="primary" @click="importFn">码单导入</el-button>
          </el-form-item>
           <el-form-item>
            <el-button type="primary" @click="modelDown">码单模板</el-button>
          </el-form-item>
           <!-- <el-form-item>
            <el-button type="primary" @click="zhuangchuanFN">装船</el-button>
          </el-form-item> -->
           <el-form-item>
            <el-button type="primary" @click="xiechuanFN">卸船</el-button>
          </el-form-item>
           <!-- <el-form-item>
            <el-button type="primary" @click="zhuanhuanFN">转换</el-button>
          </el-form-item> -->
          <el-form-item>
            <el-button type="primary" @click="carrierFN">承运方</el-button>
          </el-form-item>
          <!-- <el-form-item>
            <el-button type="primary" @click="carriageFleetFN">目的港口变更</el-button>
          </el-form-item> -->
          <el-form-item>
            <el-button type="primary" @click="carriageFleetFN">交货地变更</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="damageFN">上报货损</el-button>
          </el-form-item>
          <!-- <el-form-item>
            <el-button type="primary" @click="exportFn"  :disabled="isDisable">导出</el-button>
          </el-form-item> -->
          <el-form-item>
           <p class="margin0">总重量：<span class="red">{{dataJson.allWeight}}</span>吨</p>
          </el-form-item>
          <el-form-item>
           <p class="margin0">总件数：<span class="red">{{dataJson.allNum}}</span>件</p>
          </el-form-item>
          <!-- <el-form-item>
           <p class="margin0">在船重量<span class="red">{{dataJson.inShipWeight}}</span>吨</p>
          </el-form-item> -->
          <!-- <el-form-item>
           <p class="margin0">入库重量<span class="red">{{dataJson.inWarehouseWeight}}</span>吨</p>
          </el-form-item>
          <el-form-item>
           <p class="margin0">自提重量<span class="red">{{dataJson.carWeight}}</span>吨</p>
          </el-form-item> -->
       </div>
      </el-form>
    </div>
    <!-- 表格 -->
    <div :style="{height:h}">
       <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"
       @row-click="handleRowClick" class="table" height="100%" style="width: 100%" center   border>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column fixed type="index"  width="55" label="序号"></el-table-column>
         <el-table-column label="操作" width="160">
          <template slot-scope="scope">
            <div>
              <el-button type="text" size="mini" v-if="scope.row.fileList.length>0" @click="lookFn(scope.row)">图片</el-button>
              <!-- <el-button type="text" size="mini" @click="editFN(scope.row)" v-if="scope.row.goodsStatus == 2">修改</el-button> -->
              <el-button type="text" size="mini" @click="editFN(scope.row)" v-if="status != 1301">修改</el-button>
            </div>
          </template>
        </el-table-column>
          <el-table-column property="cargoBarcode" width="240"  label="捆包号"></el-table-column>
          <el-table-column prop="goodsStatus"  width="260" :formatter="statusFormat" label="货物状态"></el-table-column>
          <el-table-column property="receivingAddressName" :formatter="emptyFn" width="200" label="目的港口" show-overflow-tooltip></el-table-column>
          <el-table-column property="consignAddressName" :formatter="emptyFn" width="220" label="交货地址" show-overflow-tooltip></el-table-column>
          <el-table-column property="status" width="130" label="卸船检查" >
            <template scope="scope">
              {{[ "未查验","已查验" ][scope.row.checkStatus-1]}}
            </template>
          </el-table-column>
          <el-table-column property="isDamage" label="是否货损"  min-width="130">
          <template scope="scope">
              <div>{{scope.row.isDamage=='1'?'是':'否'}}</div>
          </template>
        </el-table-column>
        <el-table-column property="shipUnloadType" label="卸船类型" min-width="130">
          <template scope="scope">
            <div v-if="scope.row.shipUnloadType">
             {{[ "入库", "自提","过驳" ][scope.row.shipUnloadType-1]}}
            </div>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column property="carriageFleetName" :formatter="emptyFn" width="200" label="承运方" show-overflow-tooltip></el-table-column>
        <!-- <el-table-column property="warehouseAddressName" :formatter="emptyFn" width="200" label="入库地址" show-overflow-tooltip></el-table-column> -->
        <el-table-column property="shipUnloadRemark" :formatter="emptyFn" width="200" label="卸船备注" show-overflow-tooltip></el-table-column>
        <el-table-column prop="shipUnloadTime" width="200" :formatter="dateTimeFormat"  label="卸船时间"></el-table-column>
        <!-- <el-table-column property="goodsStatus" label="卸船类型" >
          <template scope="scope">
            <div>
              <span v-if="scope.row.shipUnloadType">{{[ "入库", "自提" ][scope.row.shipUnloadType-1]}}</span>
              <span v-if="!scope.row.shipUnloadType">-</span>
            </div>
          </template>
        </el-table-column> -->
        <el-table-column prop="customerName"  width="260" :formatter="emptyFn" label="客户名称"></el-table-column>
        <el-table-column property="productTypeName" :formatter="emptyFn" width="120" label="货物类型"></el-table-column>
        <!-- <el-table-column property="isDamage" label="是否货损" >
          <template scope="scope">
              <div>{{scope.row.isDamage=='1'?'是':'否'}}</div>
          </template>
        </el-table-column> -->
        <el-table-column property="productName" :formatter="emptyFn" label="品名"></el-table-column>
        <el-table-column property="model" width="120" :formatter="emptyFn" label="材质"></el-table-column>
        <el-table-column property="specification" width="120" :formatter="emptyFn" label="规格"></el-table-column>
        <el-table-column property="weight" width="100" :formatter="emptyFn" label="重量(吨)"></el-table-column>
        <el-table-column prop="number" width="120" :formatter="emptyFn" label="件数(件)"></el-table-column>
        <el-table-column property="itemNo" width="120" :formatter="emptyFn" label="合同号"></el-table-column>
        <el-table-column property="contractNumber" :formatter="emptyFn" width="120" label="合约号"></el-table-column>
        <el-table-column property="sign" width="100" :formatter="emptyFn" label="标记"></el-table-column>
        <el-table-column prop="createUserName" width="200" :formatter="emptyFn"  label="创建人"></el-table-column>
        <el-table-column prop="relCreateTime" width="200" :formatter="dateTimeFormat"  label="创建时间"></el-table-column>
        <!-- <el-table-column prop="shipMentTime" width="160" :formatter="dateTimeFormat"  label="装船时间"></el-table-column> -->
        <!-- <el-table-column prop="shipUnloadTime" width="200" :formatter="dateTimeFormat"  label="卸货时间"></el-table-column> -->
        <el-table-column prop="cargoBin" width="200" :show-overflow-tooltip="true" :formatter="emptyFn"  label="舱货位号">
          <template scope="scope">
            <div >
              {{scope.row.cargoHold}}-{{scope.row.cargoArea}}-{{scope.row.cargoFloor}}{{scope.row.cargoBin}}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="collectPerson" width="200" :show-overflow-tooltip="true" :formatter="emptyFn"  label="舱货位号采集人"></el-table-column>
        <el-table-column prop="collectTime" width="160" :formatter="dateTimeFormat"  label="舱货位号采集时间"></el-table-column>
        <el-table-column prop="collectType" width="200" :show-overflow-tooltip="true" :formatter="emptyFn"  label="舱货位采集方式"></el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[5,25,50,100,200,1000]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 卸船 -->
    <shipUnload :row-data="row" v-if="shipUnloadFlag" @save="HCsave" @destroy="destroy">></shipUnload>
     <!-- 导入 -->
    <importC   v-if="importDialog" @DRsave="DRsave" @destroy="destroy"></importC>
    <!-- 修改 -->
     <el-dialog  title="货物信息"  :visible.sync="dialogGood" width="460px"  :close-oni-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
       <el-form :inline="true" :rules="rules" :model="goodFrom" ref="goodFrom"  class="demo-form-inline jiaoyan addgood" label-width="110px" size="mini">
          <el-form-item label="捆包号:" prop="cargoBarcode">
            <el-input   :rows="3"  placeholder="" maxlength="30" v-model="goodFrom.cargoBarcode" :readonly="true"></el-input>
          </el-form-item>
            <el-form-item label="货物类型:" class="jiage" prop="productType">
              <el-select  v-model="goodFrom.productType"  value-key="productId"  placeholder="请选择" >
                <el-option v-for="item in productTypes" :label="item.name" :value="item" :key="item.productId"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="重量:" prop="weight"  class="jiage">
              <el-input   :rows="3"  placeholder="" maxlength="10" v-model="goodFrom.weight"></el-input><span class="danwei">吨</span>
            </el-form-item>
            <el-form-item label="品名:" prop="productName">
              <el-input   :rows="3"  placeholder="" maxlength="30" v-model="goodFrom.productName"></el-input>
            </el-form-item>
            <el-form-item label="合同号:" prop="itemNo">
              <el-input   :rows="3"  placeholder="" maxlength="30" v-model="goodFrom.itemNo"></el-input>
            </el-form-item>
            <el-form-item label="合约号:" prop="contractNumber">
              <el-input   :rows="3"  placeholder="" maxlength="30" v-model="goodFrom.contractNumber"></el-input>
            </el-form-item>
            <!-- <el-form-item label="规格:" prop="specification">
              <el-input   :rows="3"  placeholder="" maxlength="30" v-model="goodFrom.specification"></el-input>
            </el-form-item> -->
            <el-form-item label="长度:" prop="length" class="jiage">
              <el-input   :rows="3"  placeholder="" maxlength="30" v-model="goodFrom.length"></el-input><span class="danwei">米</span>
            </el-form-item>
              <el-form-item label="宽度:" prop="width" class="jiage">
              <el-input   :rows="3"  placeholder="" maxlength="30" v-model="goodFrom.width"></el-input><span class="danwei">米</span>
            </el-form-item>
              <el-form-item label="厚度:" prop="thickness" class="jiage">
              <el-input   :rows="3"  placeholder="" maxlength="30" v-model="goodFrom.thickness"></el-input><span class="danwei">米</span>
            </el-form-item>
            <el-form-item label="材质:" prop="model">
              <el-input   :rows="3" placeholder="" maxlength="30" v-model="goodFrom.model"></el-input>
            </el-form-item>
        </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button id="quxiao" @click="dialogGood = false">取 消</el-button>
        <el-button type="primary" id="save" @click="goodSave()">确 定</el-button>
      </span>
   </el-dialog>
    <!-- 查看 -->
      <el-dialog  title="查看"  :visible.sync="dialog" width="900px"  @close="closeDialog" :close-oni-click-modal="false" :close-on-press-escape="false" center>
    <div>
        <!-- <div class="addressBox" style="margin-bottom:20px" >
          <h4 class="title" >
            <span><i class="fa fa-bookmark-o iconFont" aria-hidden="true"></i>装船凭证</span>
          </h4>
           <div class="imgBox">
                <el-image
                 v-for="(item,index) in loadingImgs" :src="item" :key="index"
                  style="width: 260px; height: 200px"
                  :preview-src-list="getSrcList(index,loadingImgs)">
                </el-image>
            </div>
        </div> -->
         <div class="addressBox" >
          <h4 class="title" v-if="unloadImgs.length>0">
            <span><i class="fa fa-bookmark-o iconFont" aria-hidden="true"></i>卸船凭证</span>
          </h4>
           <div class="imgBox">
                <el-image
                 v-for="(item,index) in unloadImgs" :src="item" :key="index"
                  style="width: 260px; height: 200px"
                  :preview-src-list="getSrcList(index,unloadImgs)">
                </el-image>
            </div>
        </div>
    </div>
     <span slot="footer" class="dialog-footer">
        <el-button @click="dialog = false" type="primary">关 闭</el-button>
      </span>
   </el-dialog>
    <!--承运方-->
    <el-dialog title="承运方" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="carrierMark"  width="500px" center>
      <div style="margin: 28px 0 0 0;">
        <el-form :inline="true" :rules="rules" :model="carrierForm" ref="carrierForm"  class="demo-form-inline jiaoyan addgood" label-width="160px" size="mini">
          <el-form-item label="承运方:" prop="carriageFleetName">
            <el-input maxlength="50"  placeholder="" v-model="carrierForm.carriageFleetName"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="carrierMark = false" size='mini' >取消</el-button>
        <el-button type="primary" size="mini" @click="saveFn('carrierForm')" >保 存</el-button>
      </span>
    </el-dialog>
     <el-dialog title="交货地变更" :close-on-click-modal="false"  @close="closeDialog"  :close-on-press-escape="false" :visible.sync="carriageFleetMark"  width="500px" center>
      <div style="margin: 28px 0 0 0;">
        <el-form :inline="true" :rules="rules" :model="carriageFleetForm" ref="carriageFleetForm"  class="demo-form-inline jiaoyan addgood" label-width="160px" size="mini">
          <!-- <el-form-item label="交货地:" prop="receivingAddressName">
            <el-input maxlength="50"  placeholder="" v-model="carrierForm.receivingAddressName"></el-input>
          </el-form-item> -->
          <el-form-item label="目的港口:" prop="addressName" class="jiage"  :rules="[{required: false}]">
            <el-select  v-model="carriageFleetForm.addressName"  value-key="id"  placeholder="请选择" filterable>
              <el-option v-for="(item,index) in MTList" :label="item.addressName" :value="item.addressName" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="交货地址:" prop="consignAddressName">
            <el-input maxlength="50"  placeholder="" v-model="carriageFleetForm.consignAddressName"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="carriageFleetMark = false" size='mini' >取消</el-button>
        <el-button type="primary" size="mini" @click="JHsaveFn('carriageFleetForm')" >保 存</el-button>
      </span>
    </el-dialog>
    <el-dialog title="上报货损" v-if="damageMark" :close-on-click-modal="false"  @close="closeDialog"  :close-on-press-escape="false" :visible.sync="damageMark"  width="530px" center>
      <div style="margin: 28px 0 0 0;">
        <el-form :inline="true" :rules="rules" :model="damageForm" ref="damageForm"  class="demo-form-inline jiaoyan addgood" label-width="160px" size="mini">
          <el-form-item label="捆包号:" prop="cargoBarcode"  label-width="90px">
            <el-input  placeholder=""   v-model="damageForm.cargoBarcode" disabled></el-input>
          </el-form-item>
          <div class="imgBox">
            <uploadImgs :imgList.sync='imgList' :max=5 @remove='remove' ></uploadImgs>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="damageMark = false" size='mini' >取消</el-button>
        <el-button type="primary" size="mini" @click="HSsaveFn('damageForm')" >保 存</el-button>
      </span>
    </el-dialog>
</div>
</template>

<script>
import uploadImgs from '@/components/uploadImgs.vue'
import { compressImages } from '@/utils/compressImages'
import { sBusinessGoodsRelList, impSBusinessAndGoods, BGRshipMent, BGRdelete, sGoodsUpdate, listWeight, goodsCarriageFeel, dropDownList, changeGoodsReceivingAddress, sAddressList, isDamage } from '@/api/shipping'
import { emptyFn, dateTimeFormat } from '@/utils/util'
import importC from '@/components/import.vue'
import shipUnload from '@/views/shipping/shipingBill/shipUnload.vue'
import { exportExcel } from '@/utils/fileDown.js'
export default {
  components: {
    importC,
    shipUnload,
    uploadImgs
  },
  data () {
    var id = this.$route.query.id
    var status = this.$route.query.status
    return {
      imgList: [],
      damageMark: false,
      damageForm: {},
      carriageFleetForm: {},
      carriageFleetMark: false,
      isDisable: false,
      carrierForm: {},
      carrierMark: false,
      fileList: [],
      dialog: false,
      loadingImgs: [],
      unloadImgs: [],
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      h: '500px',
      weight: '0.00',
      importDialog: false,
      tableList: [],
      loading: false,
      total: 0,
      id: id,
      status: status,
      businessId: '',
      searchFrom: {
        pageNo: 1,
        pageSize: 50,
        // status: 1,
        shipDateId: id
      },
      shipUnloadFlag: false,
      dialogGood: false, // 修改
      productTypes: [],
      goodFrom: {},
      isAdd: false,
      rules: {
        // carriageFleetName: [
        //   { required: true, message: '请输入承运方', trigger: 'blur' }
        // ],
        addressName: [
          { required: true, message: '请选择目的港口', trigger: 'blur' }
        ],
        cargoBarcodes: [
          { required: true, message: '请输入捆包号', trigger: 'blur' }
        ],
        productType: [
          { required: true, message: '请选择货物类型', trigger: 'blur' }
        ],
        productName: [
          { required: true, message: '请输入品名', trigger: 'blur' }
        ],
        itemNo: [
          { required: true, message: '请输入合同号', trigger: 'blur' }
        ],
        contractNumber: [
          { required: true, message: '请输入合约号', trigger: 'blur' }
        ],
        model: [
          { required: true, message: '请输入材质', trigger: 'blur' }
        ],
        weight: [
          { required: true, message: '请输入重量', trigger: 'blur' },
          this.rule.weight
        ]
      },
      MTList: [],
      row: {},
      msg: null,
      dataJson: {},
      ids: []
    }
  },
  created () {
    this.getList(this.searchFrom)
    dropDownList().then(res => {
      this.productTypes = res
    })
    sAddressList({ addressType: 2 }).then(res => {
      this.MTList = res
    })
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 135) + 'px'
  },
  methods: {
    statusFormat (row, column, cellValue) {
      switch (cellValue) {
        case 2:
          return '已在船'
        case 3:
          return '已卸船'
      }
    },
    damageFN () {
      const selectData = this.$refs.table.selection
      if (selectData.length < 1) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else if (selectData.length > 1) {
        this.$alert('只能操作一条！', '系统提示')
      } else {
        this.ids = []
        selectData.some((item, index) => {
          this.$set(this.damageForm, 'cargoBarcode', item.cargoBarcode)
          if (this.status != 1301) {
            this.$set(this.damageForm, 'businessId', item.businessId)
            this.damageMark = true
            this.imgList = []
          } else {
            this.$alert('该状态下的货物不能进行上报货损操作！', '系统提示')
            return true
          }
        })
      }
    },
    // 删除图片
    remove (file) {
      // this.damageForm.delFileIds.push(file.id)
    },
    HSsaveFn () {
      if (this.imgList.length == 0) {
        this.$alert('请上传货损图片！', '系统提示')
        return
      }
      this.$set(this.damageForm, 'shipDateId', this.id)
      this.$refs.damageForm.validate((valid) => {
        if (valid) {
          let imgfile = new FormData()
          imgfile.set('param', JSON.stringify(this.damageForm))
          let that = this
          let arr = []
          console.log(this.imgList)
          this.imgList.forEach(item => {
            if (!item.id) {
              arr.push(item)
            }
          })
          compressImages(arr, {
            width: 1000
          }).then(result => {
            console.log(result, '33')
            result.forEach(item => {
              imgfile.append('files', item)
            })
            that.save1(imgfile)
          })
        }
      })
    },
    save1 (data) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      isDamage(data).then(res => {
        loading.close()
        this.$message({
          message: '上传成功！',
          type: 'success'
        })
        this.damageMark = false
        this.getList(this.searchFrom)
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    exportFn () {
      let form = { ...this.searchFrom }
      exportExcel(
        this.global.shipping + '/sBusinessGoodsRel/exportSBusinessGoodsRel',
        form,
        '码单列表'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 点击图片放大
    getSrcList (index, arr) {
      return arr.slice(index).concat(arr.slice(0, index))
    },
    // 查看
    lookFn (row) {
      this.fileList = row.fileList
      this.dialog = true
      this.loadingImgs = []
      this.unloadImgs = []
      this.fileList.forEach(item => {
        if (item.type == 1) {
          this.loadingImgs.push(item.fileUrlOSS)
        }
        if (item.type == 2) {
          this.unloadImgs.push(item.fileUrlOSS)
        }
      })
    },
    // 添加
    addFN () {
      this.dialogGood = true
      this.isAdd = true
      dropDownList({
        productCategory: 2
      }).then(res => {
        this.productTypes = res
      })
    },
    // 修改
    // editFN () {
    //   const selectData = this.$refs.table.selection
    //   if (selectData.length != 1) {
    //     this.$alert('请选择一条要操作的数据', '系统提示')
    //   } else {
    //     this.dialogGood = true
    //     this.isAdd = false
    //     this.goodFrom = JSON.parse(JSON.stringify(selectData[0]))
    //     dropDownList({
    //       productCategory: this.goodFrom.productCategory
    //     }).then(res => {
    //       this.productTypes = res
    //     })
    //     this.$set(this.goodFrom, 'productType', { productId: selectData[0].productTypeId, name: selectData[0].productTypeName })
    //   }
    // },
    // goodSave () {
    //   this.$refs.goodFrom.validate((valid) => {
    //     if (valid) {
    //       const loading = this.$loading({
    //         lock: true,
    //         text: '正在处理...'
    //       })
    //       this.goodFrom.distributionId = this.row.id
    //       this.goodFrom.productTypeId = this.goodFrom.productType.productId
    //       this.goodFrom.productTypeName = this.goodFrom.productType.name
    //       if (this.isAdd) {

    //       } else {
    //         sGoodsUpdate(this.goodFrom).then(res => {
    //           loading.close()
    //           this.dialogGood = false
    //           this.isEdit = true
    //           this.getList(this.searchFrom)
    //         }).catch(error => {
    //           this.$message({
    //             showClose: true,
    //             message: error.message,
    //             type: 'error',
    //             onClose () {
    //               loading.close()
    //             }
    //           })
    //         })
    //       }
    //     }
    //   })
    // },
    editFN (row) {
      this.dialogGood = true
      this.isAdd = false
      this.goodFrom = { ...row }
      dropDownList({
        // productCategory: this.goodFrom.productCategory
      }).then(res => {
        this.productTypes = res
      })
      this.$set(this.goodFrom, 'productType', { productId: row.productTypeId, name: row.productTypeName })
      this.$set(this.goodFrom, 'shipDateId', this.id)
      if (row.specification) {
        let arr = row.specification.split('x')
        arr.forEach((item, index) => {
          if (index == 0) {
            this.$set(this.goodFrom, 'length', item)
          } else if (index == 1) {
            this.$set(this.goodFrom, 'width', item)
          } else {
            this.$set(this.goodFrom, 'thickness', item)
          }
        })
      }
    },
    goodSave () {
      this.$refs.goodFrom.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          this.goodFrom.distributionId = this.row.id
          this.goodFrom.productTypeId = this.goodFrom.productType.productId
          this.goodFrom.productTypeName = this.goodFrom.productType.name
          if (this.isAdd) {

          } else {
            sGoodsUpdate(this.goodFrom).then(res => {
              loading.close()
              this.dialogGood = false
              this.isEdit = true
              this.$message({
                message: '修改成功',
                type: 'success'
              })
              this.getList(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          }
        }
      })
    },
    // 转换
    zhuanhuanFN () {
      const selectData = this.$refs.table.selection
      if (selectData.length < 1) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else {
        var isHQ = false
        // var weight = 0
        this.ids = []
        selectData.some((item, index) => {
          if (item.goodsStatus == 3) {
            isHQ = true
            // weight = (weight * 1000 + item.weight * 1000) / 1000
            this.ids.push(item.relId)
            if (index == 0) {
              this.$set(this, 'businessId', item.businessId)
              console.log(this.businessId)
            }
          } else {
            this.$alert('该状态下的货物不能进行转货操作', '系统提示')
            isHQ = false
            return true
          }
        })
        if (isHQ) {
          this.row = {
            relIds: this.ids,
            // businessId: this.id,
            businessId: this.businessId,
            isxiechuan: false
          }
          this.shipUnloadFlag = true
        }
      }
    },
    // 卸船
    xiechuanFN () {
      const selectData = this.$refs.table.selection
      if (selectData.length < 1) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else {
        var isHQ = false
        this.ids = []
        selectData.some((item, index) => {
          // if (item.goodsStatus == 2) {
          if (this.status != 1301) {
            isHQ = true
            this.ids.push(item.relId)
            if (index == 0) {
              this.$set(this, 'businessId', item.businessId)
              console.log(this.businessId)
            }
          } else {
            this.$alert('该状态下的货物不能进行卸船操作', '系统提示')
            isHQ = false
            return true
          }
        })
        if (isHQ) {
          this.row = {
            relIds: this.ids,
            // businessId: this.id,
            businessId: this.businessId,
            isxiechuan: true
          }
          this.shipUnloadFlag = true
        }
      }
    },
    HCsave (data) {
      console.log(data)
      this.shipUnloadFlag = false
      this.getList(this.searchFrom)
    },
    // 装船
    zhuangchuanFN () {
      const selectData = this.$refs.table.selection
      var isHQ = false
      if (selectData.length < 1) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else {
        this.ids = []
        selectData.some((item, index) => {
          if (item.goodsStatus == 1) {
            isHQ = true
            this.ids.push(item.relId)
            if (index == 0) {
              this.$set(this, 'businessId', item.businessId)
              console.log(this.businessId)
            }
          } else {
            this.$alert('该状态下的货物不能进行装船操作', '系统提示')
            isHQ = false
            return true
          }
        })
        if (isHQ) {
          let thta = this
          this.$confirm('是否执行装船操作?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            // BGRshipMent({ relIds: thta.ids, businessId: thta.id }).then(res => {
            BGRshipMent({ relIds: thta.ids, businessId: thta.businessId }).then(res => {
              loading.close()
              this.$message({
                message: '装船成功',
                type: 'success'
              })
              this.getList(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          }).catch(() => {

          })
        }
      }
    },
    // 承运方
    carrierFN () {
      const selectData = this.$refs.table.selection
      if (selectData.length < 1) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else {
        this.ids = []
        selectData.some((item, index) => {
          // if (item.goodsStatus != 3) {
          if (this.status != 1301) {
            // console.log(item)
            this.ids.push(item.relId)
            this.$set(this.carrierForm, 'relIds', this.ids)
            this.carrierMark = true
            if (item.carriageFleetName) {
              this.$set(this.carrierForm, 'carriageFleetName', '')
            }
          } else {
            this.$alert('该状态下的货物不能进行承运方操作！', '系统提示')
            return true
          }
        })
      }
    },
    saveFn () {
      this.$refs.carrierForm.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          goodsCarriageFeel(this.carrierForm).then(res => {
            loading.close()
            this.$message({
              message: '添加成功',
              type: 'success'
            })
            this.carrierMark = false
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    // 交货地变更
    carriageFleetFN () {
      const selectData = this.$refs.table.selection
      if (selectData.length < 1) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else {
        this.ids = []
        selectData.some((item, index) => {
          // if (item.goodsStatus != 3) {
          if (this.status != 1301) {
            this.ids.push(item.relId)
            this.$set(this.carriageFleetForm, 'goodRelIdList', this.ids)
            this.carriageFleetMark = true
            // if (item.addressName) {
            //   this.$set(this.carriageFleetForm, 'addressName', '')
            // }
          } else {
            this.$alert('该状态下的货物不能进行交货地变更操作！', '系统提示')
            return true
          }
        })
      }
    },
    JHsaveFn () {
      if (!this.carriageFleetForm.addressName) {
        this.$set(this.carriageFleetForm, 'addressName', '')
      }
      if (!this.carriageFleetForm.consignAddressName) {
        this.$set(this.carriageFleetForm, 'consignAddressName', '')
      }
      this.$set(this.carriageFleetForm, 'shipDateId', this.id)
      if (this.carriageFleetForm.addressName) {
        this.carriageFleetForm.addressId = this.MTList.find(item1 => item1.addressName === this.carriageFleetForm.addressName).id
      }
      this.$refs.carriageFleetForm.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          console.log(this.carriageFleetForm)
          console.log(111111111111)
          changeGoodsReceivingAddress(this.carriageFleetForm).then(res => {
            loading.close()
            this.$message({
              message: '变更成功',
              type: 'success'
            })
            this.carriageFleetMark = false
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },

    // 导入
    importFn () {
      if (this.status != 1301) {
        this.importDialog = true
      } else {
        this.$alert('该状态下的货物不能进行码单导入操作！', '系统提示')
        return true
      }
      // this.importDialog = true
    },
    // 导入模板下载
    modelDown () {
      var tempwindow = window.open('_blank') // 先打开页面
      tempwindow.location = 'https://cloud.zw56.com/ship/%E7%A0%81%E5%8D%95%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'// 后更改页面地址
    },
    DRsave (formData) {
      formData.append('shipDateId', this.id)
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      impSBusinessAndGoods(formData).then(res => {
        loading.close()
        this.importDialog = false
        var that = this
        that.getList(that.searchFrom)
        this.msg = this.$message({
          showClose: true,
          message: res,
          duration: 0,
          type: 'success',
          onClose () {

          }
        })
      }).catch(error => {
        this.msg = this.$message({
          showClose: true,
          message: error.message,
          duration: 0,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    destroy () {
      this.importDialog = false
      this.shipUnloadFlag = false
    },
    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcode) { this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcode.split(/[(\r\n)\r\n]+/) } else {
        this.searchFrom.cargoBarcodes = ''
      }

      this.getList(this.searchFrom)
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      sBusinessGoodsRelList(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
        listWeight(searchFrom).then(res => {
          this.dataJson = res
        })
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 删除
    deleteFN () {
      const selectData = this.$refs.table.selection
      if (selectData.length < 1) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else if (selectData.length > 100) {
        this.$alert('删除条数上限100条', '系统提示')
      } else {
        let isHQ = false
        this.ids = []

        selectData.some(item => {
          // if (item.goodsStatus == 2) {
          if (this.status != 1301) {
            this.ids.push(item.relId)
            isHQ = true
          } else {
            this.$alert('该数据状态不能进行删除操作', '系统提示')
            isHQ = false
            return true
          }
        })
        if (isHQ) {
          this.$confirm('是否执行删除操作?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            BGRdelete({ relIds: this.ids }).then(res => {
              loading.close()
              this.$message({
                message: '删除成功',
                type: 'success'
              })
              this.getList(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          }).catch(() => {

          })
        }
      }
    },
    closeDialog () {
      this.goodFrom = {}
      this.carriageFleetForm = {}
      this.damageForm = {}
      // this.max = 0
    },
    back () {
      this.$router.go(-1)// 返回上一层
    },
    // 重置
    resetForm (formName) {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        // businessId: this.id,
        // businessId: this.businessId,
        shipDateId: this.id,
        createTime: null
      }
    }

  },
  destroyed () {
    if (this.msg) {
      this.msg.close()
    }
  }
}
</script>

<style scoped  lang='less'>
.searchBox{
  display: flex;
  .inpBox .el-date-editor{
      width: 350px!important;
  }
}
/deep/.autoBox .el-form-item__content{
  width:150px;
}
/deep/ .gjhBox{
  width: 268px;
/deep/ .el-form-item__label{
       width: 60px!important;
    flex-shrink: 0;
 }
 /deep/.el-form-item__content{
   flex-shrink: 0;
    width: 150px;
 }
}
.addgood{
  /deep/.el-form-item__content{
    width: 193px;
  }
}
/deep/.el-input.is-disabled .el-input__inner {
    color: #333333;
    cursor: not-allowed;
}
</style>
